import { render, staticRenderFns } from "./clientStatus.vue?vue&type=template&id=34046333&scoped=true&"
import script from "./clientStatus.js?vue&type=script&lang=js&"
export * from "./clientStatus.js?vue&type=script&lang=js&"
import style0 from "./clientStatus.scss?vue&type=style&index=0&id=34046333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34046333",
  null
  
)

export default component.exports